import roles from './roles';
import typesStructures from './typesStructures';
import permissions from './permissions';
import pages from './pages';
import modules from './modules';
import cv from './cv';
import icons from './icons';

export default {
  ...roles,
  ...typesStructures,
  ...permissions,
  ...pages,
  ...modules,
  ...cv,
  ...icons,

  delayMessageHeaderToDisappear: 3000,

  TEMPLATE_DEFAULT:{
    name: 'multi3',
    nameBis: 'clea',
    module: 'compperso',
    page: 'compcle',
  },

  //COMPETENCES_SCOLAIRE_CRITERIONS:['Non Observable', 'Non Acquis', 'En cours d\'acquisition', 'Acquis'],

  MENU_LIST_SORT_ORDER: [
    'Dashboard',
    'neopass_form',
    'Neopass',
    'CurriculumVitae',
    'Cartoindcompperso',
    'Informationsgénérales',    
    'JobDescription',
    'ReferentielFormation',
    'multi3',
    'Documents',
    'Competences',
    'RechercheCompetences',
    'HelpContact'
  ],

  /* FILE_RIGHTS:{
    OWNER_RIGHTS: {owner: true,  admin: true,  edit: true,  read: true},
    ADMIN_RIGHTS: {owner: false, admin: true,  edit: true,  read: true},
    EDIT_RIGHTS:  {owner: false, admin: false, edit: true,  read: true},
    READ_RIGHTS:  {owner: false, admin: false, edit: false, read: true},
  }, */
  FILE_RIGHTS:{
    ADMIN_RIGHTS: 'admin',
    EDIT_RIGHTS:  'edit',
    READ_RIGHTS:  'read',
  },

  FILE_TYPES:{
    img:['jpg', 'jpeg', 'png', 'gif', 'bmp', 'heic', 'heif'],
    pdf:['pdf'],
    doc:['doc', 'docx', 'odt'],
    xls:['xls', 'xlsx', 'ods'],
    ppt:['pps','ppt','pptx', 'odp']
  },

  DISKS:{
    main: 'depotdocs'
  },

  LIST_EVALUATION_PAGES:[
    'compcle',
    'informatique',
    'langue',
    'aptitudes_perso',
    'comportement_social',
    'aptitudes_pro',
    'productivite',
    'attitudes_pro',
    'regles',
    'p1',
    'p2',
    'p3',
    'p4',
    'p5',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5'
  ],

  CV_PAGES: {
    dashboard:[
      {name: 'shaping', libelle: 'Mise en forme', icon: 'color-palette'},
      {name: 'title', libelle: 'Titre et accroche', icon: 'edit-2'},
      {name: 'personnal', libelle: 'Informations personnelles', icon: 'person'},
      {name: 'formations', libelle: 'Formations', icon: 'award'},
      {name: 'atouts', libelle: 'Valeurs personnelles', icon: 'person-add'},
      {name: 'comp', libelle: 'Compétences', icon: 'checkmark-circle-2'},
      {name: 'needs', libelle: 'Besoins au travail', icon: 'options'},
      {name: 'success', libelle: 'Clés de réussite', icon: 'key'},
      {name: 'langues', libelle: 'Langues', icon: 'message-circle'},
      {name: 'hobbies', libelle: 'Centres d\'intérêt', icon: 'heart'},
    ],
    basic: [
      {name: 'shaping', libelle: 'Mise en forme', icon: 'color-palette'},
      {name: 'title', libelle: 'Titre et accroche', icon: 'edit-2'},
      {name: 'personnal', libelle: 'Informations personnelles', icon: 'person'},
      {name: 'formations', libelle: 'Formations', icon: 'award'},
      {name: 'pro', libelle: 'Expériences professionnelles', icon: 'briefcase'},
      {name: 'comp', libelle: 'Compétences', icon: 'checkmark-circle-2'},
      {name: 'langues', libelle: 'Langues', icon: 'message-circle'},
      {name: 'hobbies', libelle: 'Centres d\'intérêt', icon: 'heart'},
    ]
  },

  CV_TYPES:{
    BASIC: 'basic',
    DASHBOARD: 'dashboard',
  },

  MILESTONES_WITH_COMMITMENT_UNIT_PRICE:{
    0: 9.9,
    25: 8.9,
    50: 7.9,
    100: 6.9,
    200: 5.9,
  },
    
  MILESTONES_WITHOUT_COMMITMENT_UNIT_PRICE:{
    0: 12.9,
    25: 11.9,
    50: 10.9,
    100: 9.9,
    200: 8.9,
  },

  FRISE_CHRONOLOGIQUE_DECORATION_BY_EVENT:{
    parcours:{
      'Formation initiale': {color:'text-teal-600', bg:'bg-teal-100', line:'bg-teal-600', border:'border-teal-600', icon:'award'},
      'Formation professionnelle continue': {color:'text-teal-600', bg:'bg-teal-100', line:'bg-teal-600', border:'border-teal-600', icon:'award'},
      'Stage': {color:'text-teal-600', bg:'bg-teal-100', line:'bg-teal-600', border:'border-teal-600', icon:'briefcase'},
      'Parcours professionnel': {color:'text-teal-600', bg:'bg-teal-100', line:'bg-teal-600', border:'border-teal-600', icon:'briefcase'},
      'Autre expérience': {color:'text-teal-600', bg:'bg-teal-100', line:'bg-teal-600', border:'border-teal-600', icon:'radio-button-off'},
    },
    event:{
      'Hospitalisation':{color:'text-indigo-600', bg:'bg-indigo-200', line:'bg-indigo-600', border:'border-indigo-600', icon:'hospital'},
      'Arrêt maladie': {color:'text-indigo-600', bg:'bg-indigo-200', line:'bg-indigo-600', border:'border-indigo-600', icon:'person-remove'},
      'Naissance': {color:'text-pink-600', bg:'bg-pink-100', line:'bg-pink-600', border:'border-pink-600', icon:'nipple'},
      'Mariage': {color:'text-pink-600', bg:'bg-pink-100', line:'bg-pink-600', border:'border-pink-600', icon:'love'},
      'Divorce': {color:'text-pink-600', bg:'bg-pink-100', line:'bg-pink-600', border:'border-pink-600', icon:'heart-broken'},
      'Déménagement': {color:'text-orange-600', bg:'bg-orange-100', line:'bg-orange-600', border:'border-orange-600', icon:'home'},
      'Reconversion': {color:'text-teal-600', bg:'bg-teal-100', line:'bg-teal-600', border:'border-teal-600', icon:'briefcase'},
      'Autre': {color:'text-gray-600', bg:'bg-gray-200', line:'bg-gray-600', border:'border-gray-600', icon:'radio-button-off'},
    },
    rqth:{
      'RQTH': {color:'text-indigo-600', bg:'bg-indigo-200', line:'bg-indigo-600', border:'border-indigo-600', icon:'hospital'},
    },
  },
  
  // Type de compétences dans les filtres pour le module Compétences
  COMPETENCES_FILTER_TYPES:{
    perso: 'perso',
    socio: 'socio',
    pro: 'pro'
  },

  TEMPLATE_TYPES:{
    multi1: 'multi1',
    multi2: 'multi2',
    multi3: 'multi3',
    pro: 'pro',
    sco: 'sco'
  }
};
